import { render, staticRenderFns } from "./AdminHazmatCodes.vue?vue&type=template&id=113fa098&scoped=true&"
import script from "./AdminHazmatCodes.vue?vue&type=script&lang=js&"
export * from "./AdminHazmatCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113fa098",
  null
  
)

export default component.exports